// 通用二次确认弹框(删除组 / 删除域名共用)。
import { Button } from '@dogdisk/shared'

export function ConfirmDialog({
  title,
  message,
  confirmLabel = '删除',
  busy = false,
  onConfirm,
  onCancel,
  testid,
}: {
  title: string
  message: string
  confirmLabel?: string
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
  testid?: string
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      data-testid={testid}
    >
      <div className="w-full max-w-sm rounded bg-white p-6">
        <h3 className="mb-2 text-lg font-semibold">{title}</h3>
        <p className="mb-4 text-sm text-gray-500">{message}</p>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onCancel}>
            取消
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={onConfirm}
            disabled={busy}
            data-testid={testid ? `${testid}-confirm` : undefined}
          >
            {busy ? '…' : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
